import { ExpandLess, ExpandMore } from "@material-ui/icons";
import React from "react";
import { MobileBtnsContainer, OrderButtonMobile } from "./styles";
import { OrderButtonsSpecific } from "./types";

type Props = OrderButtonsSpecific;

const MobileOrderButtons = ({
  isAscendingActive,
  isDescendingActive,
  ascendingCallback,
  descendingCallback,
}: Props) => (
  <MobileBtnsContainer>
    <OrderButtonMobile
      active={isAscendingActive}
      onClick={ascendingCallback}
      type="button"
      aria-label="set column order to ascending"
    >
      <ExpandLess />
    </OrderButtonMobile>
    <OrderButtonMobile
      active={isDescendingActive}
      onClick={descendingCallback}
      type="button"
      aria-label="set column order to descending"
    >
      <ExpandMore />
    </OrderButtonMobile>
  </MobileBtnsContainer>
);

export default MobileOrderButtons;
